<template>
    <b-container>
        <b-row>
            <b-col xs="12" class="border px-4 py-3 bg-light">
                <div class="linked-partner-badge-wrapper">
                    <b-badge
                        v-if="unlinkedMember"
                        pill
                        :variant="getBadgeVariant(member.active)"
                        class="ml-1">
                        Socio vinculado
                    </b-badge>
                </div>

                <div>
                    <b>Nombre y Apellidos:</b>
                    <template v-if="unlinkedMember && unlinkedMember.name && unlinkedMember.surname">
                        {{ unlinkedMember.name }} {{ unlinkedMember.surname }}
                    </template>
                    <template v-else>
                        {{ member.name }} {{ member.surname }}
                    </template>
                </div>
                <div><b>Sede:</b> {{ headquarters.name }}</div>
                <div>
                    <b>Estado:</b>
                    <b-badge
                        pill
                        :variant="getBadgeVariant(member.active)"
                        class="ml-1">
                        {{ (!!member.active ? 'Activo' : 'Baja') }}
                    </b-badge>
                    <b-badge
                        pill
                        :variant="getBadgeVariant(member.located)"
                        class="ml-1">
                        {{ (!!member.active ? 'Localizado' : 'No Localizado') }}
                    </b-badge>
                </div>
                <div class="mt-2">
                    <router-link
                        :to="unlinkedMember ? { name: 'editPartner', params: { uuid: member.uuid }, query: {tab: 3}} : { name: 'editPartner', params: { uuid: member.uuid }}"
                        target="_blank">
                        Ver Ficha Completa
                    </router-link>
                </div>
            </b-col>
        </b-row>

        <b-row class="mt-2 border p-2 bg-light align-items-center">
            <b-col>
                <h6 class="text-center">{{member.linkMembersCount}} Socios Vinculados</h6>
            </b-col>
            <b-col>
                <h6 class="text-center">{{member.cnaesCount}} CNAEs</h6>
            </b-col>
            <b-col>
                <h6 class="text-center">{{member.certificatesCount}} Certificados de Pertenencia</h6>
            </b-col>
            <b-col>
                <h6 class="text-center">{{member.feeCertificatesCount}} Certificados de Cuota</h6>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col xs="6" class="border p-4">
                <member-statistics-resume :member-id="member.uuid" :show-legend="false"/>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col xs="12" class="border p-2 bg-light">
                <div class="py-2 text-center">
                    <b>Notas</b></div>
                <hr class="mt-1 mb-2"/>
                <client-note-list
                    :notes="notes"
                    :class="[!!notes && notes.length ? 'notes-container' : '', 'm-0', 'p-0']"
                    class="m-0 p-0"></client-note-list>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ClientNoteList from '@/components/clients/notes/ClientNoteList';
    import {getClientNotes} from '@/api/client-note-api';
    import MemberStatisticsResume from '@/components/statistics/MemberStatisticsResume';

    export default {
        name: "member-summary",
        components: {
            ClientNoteList,
            MemberStatisticsResume
        },
        props: {
            member: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        uuid: null
                    }
                }
            },
            headquarters: {
              type: Object,
              required: true
            }
        },
        data: function () {
            return {
                notes: [],
                unlinkedMember: null
            }
        },
        mounted() {
            this.getNotes();
            this.unlinkedMember = this.getUnlinkedMember();
        },
        methods: {
            async getNotes() {
                this.$_loadingMixin_showLoading();
                await getClientNotes(this.member.uuid)
                    .then((notes) => {
                        this.notes = notes;
                    })
                    .catch(() => {
                        this.notes = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            getBadgeVariant(boolean) {
                return (boolean ? 'primary' : 'danger')
            },
            getUnlinkedMember() {
                if (this.member.hasOwnProperty('unlinkedMember') && this.member.unlinkedMember) {
                    console.log(this.member.unlinkedMember)
                    return this.member.unlinkedMember;
                }

                return null;
            }
        },
        watch: {
            member: function (val) {
                this.notes = [];
                this.unlinkedMember = this.getUnlinkedMember();
                this.getNotes();
            }
        }
    }
</script>

<style scoped>
    .notes-container {
        height: 250px;
        overflow-y: scroll;
    }

    .linked-partner-badge-wrapper {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
